import {
    type BundledLanguage,
    bundledLanguages,
    bundledLanguagesInfo,
    type PlainTextLanguage,
} from 'shiki';

export type AvailableLanguage = PlainTextLanguage | BundledLanguage;

export const DEFAULT_SYNTAX: PlainTextLanguage = 'text';
export const DEFAULT_SYNTAX_INFO = { key: DEFAULT_SYNTAX, title: 'Plain Text' };

export const allSyntaxes = [
    DEFAULT_SYNTAX_INFO,
    ...bundledLanguagesInfo.flatMap(({ id: key, name: title, aliases }) => {
        return [
            {
                key,
                title,
            },
            ...(aliases?.map((alias) => {
                return { key: alias, title: `${title} (${alias})` };
            }) ?? []),
        ];
    }),
] as Array<{ key: AvailableLanguage; title: string }>;

export function isAvailableLanguage(test: unknown): test is AvailableLanguage {
    return typeof test === 'string' ? test === DEFAULT_SYNTAX || test in bundledLanguages : false;
}
